import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { FormEvent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { EMAIL_REGEX_STRING, MIN_LENGTH_PASSWORD } from '../../constants';
import { logout, resetPassword } from '../../store/actions/auth';
import Button from '../FormComponents/Button';
import TextField from '../FormComponents/TextField';
import ToastMessage from '../ToastMessage/ToastMessage';

function ResetPassword() {
  const dispatch = useDispatch();
  const { resetCode } = useParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [toast, setToast] = useState('');
  const [toastType, setToastType] = useState<'success' | 'error'>('success');
  const [emailValid, setEmailValid] = useState(true);
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [formClicked, setFormClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(logout());
  }, []);

  const resetPasswordFunc = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (loading) {
      return;
    }
    setFormClicked(true);
    if (password !== confirmPassword) {
      setPasswordsMatch(false);
      setToastType('error');
      setToast('Passwords should match');
      return;
    } else {
      setPasswordsMatch(true);
    }
    setLoading(true);
    dispatch(
      resetPassword({ resetCode, email, password }, (res, message) => {
        setLoading(false);
        if (res === true) {
          navigate('/login', {
            state: {
              message: 'Password is successfully reset. Please login with the new password.',
              withPassword: true,
            },
          });
        } else {
          setToastType('error');
          setToast(message || 'Reset password failed');
        }
      }),
    );
  };

  const handleEmailChange = e => {
    setEmailValid(!!e.target.validity.valid);
    setEmail(e.target.value);
  };

  return (
    <Box>
      <Box
        component='form'
        sx={{
          '& > :not(style)': { mt: 1.5, mb: 1.5, width: '100%' },
        }}
        onSubmit={resetPasswordFunc}
      >
        <TextField
          label='Email'
          value={email}
          onChange={handleEmailChange}
          error={!emailValid}
          inputProps={{ pattern: EMAIL_REGEX_STRING }}
          helperText={!emailValid ? 'Please input a valid email' : ''}
          required
        />
        <TextField
          label='Password'
          type='password'
          value={password}
          onChange={e => setPassword(e.target.value)}
          inputProps={{ minLength: MIN_LENGTH_PASSWORD }}
          required
          error={formClicked && !passwordsMatch}
        />
        <TextField
          label='Confirm password'
          type='password'
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          inputProps={{ minLength: MIN_LENGTH_PASSWORD }}
          required
          error={formClicked && !passwordsMatch}
        />
        <Button text='Reset' style={{ marginTop: '20px' }} loading={loading} />
        <Typography display='flex' justifyContent='flex-end'>
          <Link to='/login'>Login</Link>
        </Typography>
      </Box>
      <ToastMessage toast={toast} close={() => setToast('')} messageType={toastType || 'success'} />
    </Box>
  );
}

export default ResetPassword;
